import { useContent, useNext } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { useBrowserTabTitle } from '../../../hooks/useBrowserTabTitle'
import { WixIntrosTemplate } from '../../reusable/WixIntrosTemplate'
import { Option } from './Option'
import { OptionsContainer } from './OptionsContainer'
import { Title } from './Title'
import { TWixIntrosBoxXL as Content } from './WixIntrosBoxXL.content'

export const WixIntrosBoxXL: FC = () => {
  const { content } = useContent<Content>()
  const { questionKey, options, content: questionContent } = content.question

  useBrowserTabTitle(content.browserTabTitle)
  const pageLogger = usePageLogger()
  const next = useNext()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const createOptionClickHandler = (optionKey: string) => () => {
    void pageLogger.answer({ answer: optionKey })
    next({
      [questionKey]: {
        values: [optionKey],
      },
    })
  }

  return (
    <WixIntrosTemplate>
      <Title>{questionContent.title}</Title>
      <OptionsContainer>
        {options.map((option, index) => (
          <Option
            key={option.optionKey}
            image={option.imageUrl}
            handleClick={createOptionClickHandler(option.optionKey)}
            index={index}
            description={
              option.popover?.content?.isVisible
                ? {
                    title: option.popover.content.title,
                    subtitle: option.popover.content.description,
                    url: option.popover.content.url,
                    urlText: option.popover.content.urlText,
                  }
                : undefined
            }
          />
        ))}
      </OptionsContainer>
    </WixIntrosTemplate>
  )
}
